import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';


import { MSG_NOT_FOUND, MSG_CSV_DOWNLOAD_ERROR } from '../../../configs/msgConfigs'; // 
import { LBL_APP_NAME, LBL_SETTINGS, LBL_SLNUM, LBL_CSV_TEMPLATES_DOWNLOAD, LBL_TEMPLATE_NAME, LBL_TEMPLATE_SAMPLE, LBL_DOWNLOAD, LBL_BACK_TO_SETTINGS } from '../../../configs/labelConfigs';
import { IMPORT_CSV_FILES_ARRAY, ROUTE_AFFILIATE_SETTINGS } from '../../../configs/staticConfigs';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import Toast from '../../commons/helpers/toast';
import {format as stringFormat} from 'react-string-format';
import { csvTemplateImportAction } from '../../../actions/settings/csvTemplatesImportActions';
import { CSV_TEMPLATE_IMPORT_SUCCESS, CSV_TEMPLATE_IMPORT_ERROR }  from "../../../actions";
class CSVTemplatesImport extends Component { 

    constructor(props){
        super(props)

        this.state = {
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            dptName:'',
            csvImportFileName: '',
        }
    }

    componentDidMount() { 
        document.body.classList.add('body-affiliate'); 
        document.title = LBL_APP_NAME+' - '+LBL_SETTINGS+' - '+LBL_CSV_TEMPLATES_DOWNLOAD; 
    }   
    
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }  

    onCSVTemplatesImport = (e,templateType,csvFileName) => {
        this.setState({csvImportFileName:csvFileName}, () => {
            this.props.csvTemplateImportAction({templateType:templateType}); 
        })
    }

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    componentDidUpdate(prevProps) { 
        const { csvTemplateDataActivity, csvTemplateData } = this.props;

        if (csvTemplateDataActivity && csvTemplateDataActivity!==prevProps.csvTemplateDataActivity && csvTemplateData && csvTemplateData.length > 0) {
            let arrTemp = csvTemplateDataActivity.split('~~'); 
            if(arrTemp[0]===CSV_TEMPLATE_IMPORT_SUCCESS) { 
                // console.log('csvTemplateData: ',csvTemplateData); 
                const csvData = [
                    csvTemplateData.split(",")
                ];
                // Convert data to CSV format
                // const csvContent = "data:text/csv;charset=utf-8," + csvData.map(row => row.join(",")).join("\n");
                const csvContent = csvData.map(row => row.join(",")).join("\n");

                // Create a Blob containing the CSV data
                const blob = new Blob([csvContent], { type: 'text/csv' });
            
                // Create a download link
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = this.state.csvImportFileName && this.state.csvImportFileName.trim().length > 0 ? this.state.csvImportFileName : 'data.csv';
            
                // Append the link to the document and trigger the download
                document.body.appendChild(link);
                link.click();
            
                // Clean up
                document.body.removeChild(link);
            }
            else if(arrTemp[0]===CSV_TEMPLATE_IMPORT_ERROR) {
                this.setToasterState(true,MSG_CSV_DOWNLOAD_ERROR,false); 
            }
        }
    }
    
    render(){
        const { toastMessage,toastFlag,toastSuccess } = this.state
        let userGroupData = userGroupUrlCheck(window.location);
        let lblCrew = 'Staff'
        if(userGroupData!==undefined){
            lblCrew = userGroupData.staff_name;
        }

        return(
            <>
                <div className='row' style={{width: '100%'}}>
                    <div className='margin-left-30 margin-bottom-5 padding-left-3 padding-top-5 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link></div>
                </div>
                <div className="col-md-8">
                    <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                    <div className="box">

                        <div className="box-content">
                            <div className="table-responsive">
                                <table id="data-table" className="table" style={{width:"100%"}}>
                                    <thead>
                                        <tr>
                                            <th>{LBL_SLNUM}</th>
                                            <th>{LBL_TEMPLATE_NAME}</th>
                                            <th>{LBL_TEMPLATE_SAMPLE}</th>
                                            <th></th> 
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {(IMPORT_CSV_FILES_ARRAY.length===0) && 
                                        <tr key="errorMsg">
                                            <td colSpan="4" className="text-center">{MSG_NOT_FOUND}</td>
                                        </tr>
                                    }
                                    {IMPORT_CSV_FILES_ARRAY.length && IMPORT_CSV_FILES_ARRAY.map((item,index) => { 
                                        return (
                                        <tr key={index}>  
                                            <td>{(index+1)}</td>
                                            <td>{stringFormat(item.csvName,lblCrew)}</td>
                                            <td>
                                                {/* <a href={csvURL} target="_blank" download={item.csvFileName}>{LBL_DOWNLOAD}</a>  */}
                                                <div onClick={e => this.onCSVTemplatesImport(e,item.csvType,item.csvFileName)} className='spanPointer'>{LBL_DOWNLOAD}</div>
                                            </td>
                                            <td>&nbsp;</td>
                                        </tr>
                                        ) } ) }
                                    </tbody>
                                </table>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <br></br>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </>

        )
    }
}

const mapStateToProps = (state) => { 
    return {
        csvTemplateData : state.csvTemplateImport.csvTemplateData,  
        csvTemplateDataStatus : state.csvTemplateImport.csvTemplateDataStatus, 
        csvTemplateDataActivity : state.csvTemplateImport.csvTemplateDataActivity 
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        csvTemplateImportAction:csvTemplateImportAction
    },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(CSVTemplatesImport);  ;


